// extracted by mini-css-extract-plugin
module.exports = {"main":"dropdownAccount_main__ncC2k","notOpen":"dropdownAccount_notOpen__Kaaso","trigger":"dropdownAccount_trigger__mMZ_n"};